import axios from 'axios';
import { STORE_BASE_URL } from '../BaseURL';
import getHeaders from '../../constants/headers';

export const postUserRiderPickupRequest = (storeId, riderId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' + storeId + '/rider/' + riderId + '/rider-pickup', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};